export default defineNuxtRouteMiddleware((to) => {
  if (!useUserStore().isAuthenticated) {
    return navigate({ name: `auth-login`, query: { redirect: to.fullPath } });
  }
});
